/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_Success_RateInputs */

const en_admin_funnel_col_success_rate = /** @type {(inputs: Admin_Funnel_Col_Success_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment success`)
};

/**
* | output |
* | --- |
* | "Payment success" |
*
* @param {Admin_Funnel_Col_Success_RateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_success_rate = /** @type {((inputs?: Admin_Funnel_Col_Success_RateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_Success_RateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_success_rate(inputs)
});
export { admin_funnel_col_success_rate as "admin.funnel.col.success_rate" }